import { createAPI } from '@common'
export default {
  // 扫码登陆
  getMainUserQrcode: config => createAPI('customEncryptApiName-1/0w20nbjo0vtfs0rsdpef', 'get', config)
}
